<template>
  <div id="layout-wrapper" class="page-topbar-horizontal">
    <TopBar :type="'light'" :width="'fluid'" />

    <!-- MAIN -->
    <main class="main-content" id="main-content" tabindex="-1">
      <div class="page-content mb-5">

       

        <!-- SHARE + TEZGA -->
        <div class="container-fluid p-mobile mt-0 mb-3 pt-0">
          <BRow class="align-items-center">

            <!-- SHARE -->
            <BCol cols="12" xl="auto">
              <SocialShareLinks
                :url="store.url"
                :title="store.title"
                :description="store.description"
                :nativeShare="true"
                :stripQuery="true"
              />
               <!-- PRETRAGA ispod zaglavlja (ispod 992px; od 992px je u zaglavlju) -->
        <div class="container-fluid p-mobile ">
          <SiteSearch placement="page"  class="mt-2"/>
        </div>

            </BCol>
            <!-- GOOGLE: omiljeni izvor + prijava za obavestenja; kad su obe stvari uradjene, komponenta prikazuje promo dugmad za oglas i tezgu -->
            <BCol cols="12" xl  >
              <PreferredSourceButton />
            </BCol>
          </BRow>
        </div>

        <!-- CONTENT -->
        <div class="container-fluid p-mobile">
          <slot></slot>
        </div>

      </div>

      <Footer />
      <!-- donji meni za telefon je zamenjen trakom ispod zaglavlja (MobileTabs); komponenta BottomMenu ostaje u projektu
      <BottomMenu v-if="!$screen.showDesktopAds" />
      -->
      <ClientOnly>
        <PushPrompt />
        <JoinPrompt />
      </ClientOnly>
    </main>
  </div>
</template>

<script setup>
import PreferredSourceButton from '~/components/common/PreferredSourceButton.vue'
import { BRow, BCol } from 'bootstrap-vue-next'
import SocialShareLinks from "~/components/SocialShareLinks.vue"
import Footer from "~/components/layouts/common/Footer.vue"
import TopBar from "~/components/layouts/horizontal/TopBar.vue"
import SiteSearch from "~/components/search/SiteSearch.vue"
// import BottomMenu from "../common/BottomMenu.vue"
import PushPrompt from "~/components/push/PushPrompt.vue"
import JoinPrompt from "~/components/push/JoinPrompt.vue"

import { useShareMetaStore } from "~/stores/shareMeta"
import { useCustomerLoginStore } from "~/stores/login/customer"

const store = useShareMetaStore()
const useStore = useCustomerLoginStore()
</script>

 